<template>
  <section>
    <div class="user-main">
      <div class="user-cont layui-card">
        <div class="tabs flex">
          <li @click="changetab('')" :class="status==''?'active':''">结算记录</li>
          <li @click="changetab('0')" :class="status=='0'?'active':''">待审核</li>
          <li @click="changetab('1')" :class="status=='1'?'active':''">已审核</li>

          <li @click="changetab('2')" :class="status=='2'?'active':''">审核失败</li>
        </div>
      </div>

      <el-table border :data="jiesuanorder.data" style="width: 95%;margin:auto">
        <!-- <el-table-column type="selection" width="40" label="全选"></el-table-column> -->
        <el-table-column prop="orderno" label="订单号" ></el-table-column>
        <el-table-column prop="addtime" label="提交时间" width="180"></el-table-column>
        <el-table-column prop="amount" label="金额" width="100"></el-table-column>
        <el-table-column prop="username" label="提交人"></el-table-column>
        <el-table-column prop="paytype" label="支付方式"></el-table-column>
        <el-table-column label="凭证">
          <template slot-scope="scope">
            <div class="img">
              <img :src="item_i" v-for="(item_i,index_i) in scope.row.photos" :key="index_i" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark1" label="审核备注"></el-table-column>
         <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">待审核</span>
            <span v-if="scope.row.status==1">已审核</span>
            <span v-if="scope.row.status==2">审核失败</span>
            <!-- <div class="img">
              <img :src="item_i" v-for="(item_i,index_i) in scope.row.photos" :key="index_i" />
            </div> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="fenye"
        background
        layout="prev, pager, next"
        :page-size="jiesuanorder.per_page"
        @current-change="currentPage"
        :total="jiesuanorder.total"
      ></el-pagination>
    </div>
  </section>
</template>

<script>
export default {
  name: "AwaitOrder",
  data() {
    return {
      jiesuanorder: { data: [] },
      page: 1,
      status: "",
      pagesize: "5"
    };
  },
  props: {},

  methods: {
    async getjiesuanorder() {
      let res = await await this.$fetch("Order/batchpaylist", {
        body: {
          page: this.page,
          status: this.status
        }
      });
      // alert(1)
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].photos) {
          res.data[i].photos = JSON.parse(res.data[i].photos);
        }
      }
      this.jiesuanorder = res;
    },

    changetab(type) {
      // 改变tab
      this.page = 1;
      this.status = type;
      this.getjiesuanorder();
    },
    currentPage(e) {
      this.page = e;
      this.getjiesuanorder();
    }

    // changetab()
  },
  mounted() {
    this.getjiesuanorder();
  }
};
</script>

<style lang='scss' scoped>
.tabs {
  li {
    cursor: pointer;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-right: 30px;
  }
  .active {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #f19d15 !important;
  }
}

.layui-card {
  box-shadow: none;
}

.img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.goodsInfo {
  .cont {
    width: 150px;
    margin: 0 10px;
  }
}

.cart-price {
  width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/logOrder.vue